import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './user-profile-modal.html';

const COMPONENT_NAME = 'UserProfileModal';

const UserProfileModal = ($rootScope, $uibModal, KeyboardShortcutService) => {
  const open = (parentScope, passport, backdrop = false) => {
    const modalScope = $rootScope.$new(true, parentScope);

    modalScope.passport = passport; 

    const modal = $uibModal.open({
      animation: false,
      backdrop,
      keyboard: false,
      scope: modalScope,
      template,
      windowClass: 'user-profile-modal ng-cloak'
    });

    modalScope.close = () => {
      modal.close();
      modalScope.$destroy();
      KeyboardShortcutService.pop();
    };

    KeyboardShortcutService.hideAndPush({
      'escape': {
        action: () => {
          modalScope.close();
        },
        label: 'keyboard-shortcuts.close-profile.label'
      }
    });
  };

  return { open };
};

angular.module (ComponentsModule).factory(COMPONENT_NAME, UserProfileModal);
export default COMPONENT_NAME;
